<template>
    <v-container fluid class="pa-0" style="background-color: white; position: relative;">

        <v-progress-linear v-if="loading" height="2" absolute indeterminate color="primary">
        </v-progress-linear>

        <v-row no-gutters align="center">
            <v-col>
                <h2 class="ma-3">Import history</h2>
            </v-col>
            <v-col class="px-3">
                <QTextField v-model="search" placeholder="Search" externaledit singleline clearable>
                </QTextField>
            </v-col>
            <v-col cols="auto" class="px-3">
                <v-btn icon :loading="loading" small>
                    <v-icon @click="fetch()">mdi-refresh</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <Table :data="importedFilesSearchResults" style="width: 100%" size="small" stripe>

            <template slot="empty">
                <EmptyPage v-if="!loading" :icon="'mdi-sleep'" :title="'No imports yet.'"
                    :message="'After you import a file, it will be listed here.'" class="ignoreodd">
                    <template v-slot:actions>
                        <slot name="empty-filtered-list-actions" />
                    </template>
                </EmptyPage>
            </template>

            <template>
                <TableColumn v-slot="{ row }" prop="Success" label="Status" width="80px">
                    <v-chip v-if="row.Success" color="success" dark x-small style="border-radius: 3px; height: 22px;">
                        Success
                    </v-chip>
                    <v-chip v-else color="error" dark x-small style="border-radius: 3px; height: 22px;">
                        Error
                    </v-chip>
                </TableColumn>
                <TableColumn v-slot="{ row }" prop="ImportDate" label="Date" width="130px">
                    {{ i18nFormatDateTime(row.ImportDate) }}
                </TableColumn>
                <TableColumn v-slot="{ row }" prop="FileName" label="Uploaded file" min-width="150px">
                    <v-btn v-if="row.ExcelFileName" color="primary" text style="text-transform: none;"
                        class="d-flex justify-start px-0"
                        @click="downloadImportedFile({ fileName: row.ExcelFileName })">
                        <v-icon size="20" class="mr-1">mdi-microsoft-excel</v-icon>
                        {{ row.DisplayName }}
                    </v-btn>
                </TableColumn>
                <TableColumn v-slot="{ row }" prop="Name" label="XML" width="50px">
                    <v-btn v-if="row.XmlFileName" color="primary" icon style="text-transform: none;"
                        class="d-flex justify-start px-0" @click="downloadImportedFile({ fileName: row.XmlFileName })">
                        <v-icon size="20" class="mr-1">mdi-file-xml-box</v-icon>
                    </v-btn>
                </TableColumn>
            </template>

        </Table>

    </v-container>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';
import { Table, TableColumn } from 'element-ui';
import EmptyPage from '@/components/Sections/EmptyPage.vue';
import BlobFileMixin from "@/helpers/Mixins/BlobFileMixin";

export default {
    name: 'ImportHistory',
    props: {},
    components: {
        EmptyPage,
        Table,
        TableColumn,
    },
    mixins: [ClientAPIMixin],

    data() {
        return {
            search: "",
            importedFiles: [],
            loading: false,
        };
    },

    mounted() {
        this.fetch();
    },

    methods: {
        async fetch() {
            this.loading = true;
            await this.getImportedFiles()
                .then((response) => {
                    this.importedFiles = response;
                }).finally(() => {
                    this.loading = false;
                });
        },

        async downloadImportedFile({ fileName, }) {
            await this.getImportedFile({ fileName })
                .then((response) => {
                    this.downloadFileResponse(response);
                });
        },

        async downloadFileResponse(response) {
            var blob = new Blob([response.data], { type: response.headers['content-type'] });
            var fileName = BlobFileMixin.methods.getFileNameFromResponseContentDisposition(response);
            await BlobFileMixin.methods.saveBlobToFile(blob, fileName);
        },
    },

    computed: {
        importedFilesSearchResults() {
            return this.importedFiles.filter(row =>
                !this.search
                || row.DisplayName.toLowerCase().includes(this.search.toLowerCase())
                || this.i18nFormatDateTime(row.ImportDate).toLowerCase().includes(this.search.toLowerCase())
            );
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>